import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import { PaymentBehaviourInsightsActionTypes } from './types';
import { getPaymentBehaviourInsightsConfigErrorAction, getPaymentBehaviourInsightsConfigSuccessAction, savePaymentBehaviourInsightsConfigResponseAction } from './actions';

import { _queries as queries } from '../../graphql/queries.graphql';
import { DynamicObject } from '../../utils/commonInterfaces';
import { API_NAME } from '../../config/config';
import { get } from 'lodash-es';
import client, { post } from 'src/api';

function* handleGetPaymentBehaviourInsightsConfigRequest() {
    try {
        // To call async functions, use redux-saga's `call()`.
        const res: DynamicObject = yield call(
            [client, client.graphql],
            {
                query: queries.GET_PBI_CONFIGURATION
            }
        );

        if (res.error) {
            console.log('res.error', res.error);
            yield put(getPaymentBehaviourInsightsConfigErrorAction())
        } else {
            const { GetPBIConfiguration } = res.data;
            yield put(getPaymentBehaviourInsightsConfigSuccessAction(GetPBIConfiguration));
        }
    } catch (err) {
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.');
        }
    }
}

/**
 * Function called for saving data.
 */
function* handleSavePaymentBehaviourInsightsConfigRequest({ payload: sagaPayload }: any) {
    const { payload, callback } = sagaPayload;
    try {
        yield call(post, {
            apiName: API_NAME,
            path: '/customer/save/paymentbehaviourinsightsconfiguration', 
            options: {
                body: payload
            }
        });

        yield put(savePaymentBehaviourInsightsConfigResponseAction());

        if (callback) {
            const response = {
                IsSuccess: true,
            };

            callback(response);
        }
        // calls for queries if needed
    } catch (err) {
        const error = err as any;
        yield put(savePaymentBehaviourInsightsConfigResponseAction());
        if (callback) {
            const returnData = get(error.response, 'data')
                ? error.response.data
                : { Messages: [error.message] };
            returnData.IsSuccess = false;
            callback(returnData);
        }
        if (err instanceof Error) {
            console.log('Error', err);
        } else {
            console.error('An unknown error occured.');
        }
    }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchGetPaymentBehaviourInsightsConfigRequest() {
    yield takeLatest(
        PaymentBehaviourInsightsActionTypes.GET_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST,
        handleGetPaymentBehaviourInsightsConfigRequest
    );
}

function* watchSavePaymentBehaviourInsightsConfigRequest() {
    yield takeLatest(
        PaymentBehaviourInsightsActionTypes.SAVE_PAYMENT_BEHAVIOUR_INSIGHTS_CONFIG_REQUEST,
        handleSavePaymentBehaviourInsightsConfigRequest
    );
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* paymentBehaviourInsightsSaga() {
    yield all([fork(watchGetPaymentBehaviourInsightsConfigRequest)]);
    yield all([fork(watchSavePaymentBehaviourInsightsConfigRequest)]);
}

export default paymentBehaviourInsightsSaga;
